
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { Checkbox, KeyPads, Modal, TextField } from "components"
import OrderDetailCancelModalHeader from "./OrderDetailCancelModalHeader"
import OrderDetailCancelModalFooter from "./OrderDetailCancelModalFooter"
import classes from "./index.module.scss"
import clsx from "clsx"

const initialFormState = {
  amount: 0,
  cancelReasons: "",
  refundType: "cash"
}

const initialFormErrorsState = {
  amount: "",
  cancelReasons: ""
}

const OrderDetailCancelModal = props => {
  const {
    order,
    setOrders,
    showConfirmationModal,
    setShowConfirmationModal
  } = props

  const [t, i18n] = useTranslation()

  const [form, setForm] = useState(initialFormState)
  const [formErrors, setFormErrors] = useState(initialFormErrorsState)
  const [disableKeyboard, setDisableKeyboard] = useState(false)

  const handleChange = (value, name) => {
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleExited = () => {
    setForm({ ...initialFormState })

    setFormErrors({ ...initialFormErrorsState })
  }

  const canRefundToUserWallet =
    !!order.accountId &&
    order.orderStatus === "paid" &&
    order.accountRole === "user"

  const total = order.totalBillAmount

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      show={showConfirmationModal}
      onExited={handleExited}
    >
      <div className={classes["container"]}>
        <OrderDetailCancelModalHeader
          total={total}
          amount={form.amount}
          orderStatus={order.orderStatus}
        />

        {
          order.orderStatus === "paid" &&
          <div className={classes["keypads"]}>
            <KeyPads
              value={form.amount}
              disableKeyboard={disableKeyboard}
              onChange={text => handleChange(text, "amount")}
            />
          </div>
        }

        {
          canRefundToUserWallet &&
          <div className={classes["row"]}>
            <div
              className={clsx(
                classes["refund"],
                isLtr && classes["refund-ltr"]
              )}
            >
              <Checkbox
                onChange={() => handleChange("cash", "refundType")}
                checked={form.refundType === "cash"}
              />
              <span
                className={clsx(
                  classes["refund-text"],
                  isLtr && classes["refund-text-ltr"]
                )}
              >
                {t("بازپرداخت_به_صورت_نقدی")}
              </span>
            </div>

            <div
              className={clsx(
                classes["refund"],
                isLtr && classes["refund-ltr"]
              )}
            >
              <Checkbox
                onChange={() => handleChange("wallet", "refundType")}
                checked={form.refundType === "wallet"}
              />
              <span
                className={clsx(
                  classes["refund-text"],
                  isLtr && classes["refund-text-ltr"]
                )}
              >
                {t("بازپرداخت_به_کیف_پول_کاربر")}
              </span>
            </div>
          </div>
        }

        <TextField
          componentClass="textarea"
          rows={3}
          type="text"
          label={t("دلیل_لغو_سفارش")}
          value={form.cancelReasons}
          error={formErrors.cancelReasons}
          className={classes["input"]}
          onFocus={() => setDisableKeyboard(true)}
          onBlur={() => setDisableKeyboard(false)}
          onChange={(e) => handleChange(e.target.value, "cancelReasons")}
        />

        <OrderDetailCancelModalFooter
          form={form}
          total={total}
          order={order}
          setOrders={setOrders}
          setFormErrors={setFormErrors}
          setShowConfirmationModal={setShowConfirmationModal}
          initialFormErrorsState={initialFormErrorsState}
        />
      </div>
    </Modal>
  )
}

export default OrderDetailCancelModal